import Cookies from "js-cookie";
import { SubscribeForm, SubscriptionApi } from "../lib-api";
import { CookieKeys } from "../util/cookie";
import { trackGaEvent } from "../util/gtm";
import { trackEventFbLead } from "../util/fb";
import { apiConfiguration } from "../api-configuration";
import clientConfiguration from "../client-configuration";

const subscriptionApi = new SubscriptionApi(apiConfiguration);

export const api = {
  subscribeToNewsletter: async (values: SubscribeForm, location: string) => {
    await subscriptionApi.apiSubscriptionsPut({
      subscribeForm: values,
    });
    Cookies.set(CookieKeys.EmailSubscribed, "true", { expires: 365 });

    trackGaEvent(
      "on_newsletter_subscribe",
      {
        in_section: location,
      },
      {
        email: values.email,
        city: clientConfiguration.site.name,
        country: "Danmark",
      }
    );
    trackEventFbLead("Newsletter");
  },
};
